/* Tidy Towel "3 for $39 in sets of 3" builder (templates/page.towel-deal.json). Vanilla, no deps.
   Sets of 3 (Oct 3 2026, late): every COMPLETE set of 3 is $39; towels outside a set pay full price. Totals use
   window.ttSets (assets/tt-cart-fix.js, same rule as snippets/tt-deal-calc.liquid): the most expensive towels fill the sets,
   leftovers are the cheapest. At 4/5, 7/8 ... the tray pushes "Add k more -> your next set of 3 is $13 each (save $x)".
   Round 3 (Oct 3 2026): no cap. Every add is one more towel ($13 each at 3+, per the 4 automatic discounts); tray totals come
   from the cart response. Round 2: the REAL Shopify cart is the source of truth. A pick is added at once with POST /cart/add.js
   (stock-checked); an unpick lowers that line's quantity with POST /cart/change.js (by line key). The tray syncs from
   /cart.js on load and on back/forward, and the header cart bubble is refreshed via the Section Rendering API.
   Oct 7 2026: optional Buy 2, Get 1 Free mode (D.mode = 'b2g1', /pages/buy-2-get-1), see the block near the end. */
(function () {
  var el = document.getElementById('tt-deal-data');
  if (!el) return;
  var D; try { D = JSON.parse(el.textContent); } catch (e) { return; }
  var P = D.products || {}, MIN = D.min || 3, UNIT = D.unit || 1300, SINGLE = D.single || 1699, TYPE = D.type || 'Kitchen Towel';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TH = window.Shopify && Shopify.theme, PREVIEW = TH && TH.role && TH.role !== 'main' ? TH.id : null;
  var CART_URL = ROOT + 'cart' + (PREVIEW ? '?preview_theme_id=' + PREVIEW : ''); /* preview only: keep the preview theme on /cart */
  var SEC = 'cart-icon-bubble';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var money0 = function (c) { return c % 100 ? money(c) : '$' + c / 100; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };

  var picks = [];          /* variant ids, one entry per towel, oldest first (optimistic; reconciled with the cart) */
  var C = null;            /* last full cart from Shopify (null = stale) */
  var pending = 0, chain = Promise.resolve(), synced = false, grew = false;
  var qs = new URLSearchParams(location.search), order = D.order || [];
  var presetKey = D.presets[qs.get('stack')] ? qs.get('stack') : order[0];

  function counts(list) { var m = {}; list.forEach(function (id) { m[id] = (m[id] || 0) + 1; }); return m; }
  function uniq(list) { var s = {}, o = []; list.forEach(function (id) { if (!s[id]) { s[id] = 1; o.push(id); } }); return o; }
  function nm(id) { return P[id] ? P[id].t : 'towel'; }
  /* Sets-of-3 totals from the picks' list prices (window.ttSets). Once the real cart has caught up with the taps its list
     prices are used and t.chk = what checkout charges right now when that differs (before the discount switch). t.off = the
     cart is priced ABOVE the sets-of-3 total (a deal towel not discounted), which sends checkout via /cart. */
  function setsOf(pr) {
    if (window.ttSets) return window.ttSets(pr);
    var l = pr.reduce(function (a, b) { return a + b; }, 0); return { n: pr.length, list: l, total: l, save: 0, sets: 0, k: MIN - pr.length % MIN, nextSave: 0, lo: l, loN: pr.length, loSingle: l === pr.length * SINGLE };
  }
  function totals() {
    var r = setsOf(picks.map(function (id) { return P[id] ? P[id].p : SINGLE; }));
    var t = { n: r.n, list: r.list, now: r.total, save: r.save, sets: r.sets, k: r.k, ns: r.nextSave, lo: r.lo, loSingle: r.loSingle !== false, real: false, off: false, chk: null };
    if (C && !pending && window.ttCartSets) {
      var c = window.ttCartSets(C);
      if (c.n === t.n) {
        t.list = c.list; t.now = c.total; t.save = c.save; t.sets = c.sets; t.k = c.k; t.ns = c.nextSave; t.lo = c.lo; t.loSingle = c.loSingle !== false; t.real = true;
        t.off = t.n >= MIN && c.real > c.total + 1;
        if (Math.abs(c.real - c.total) > 1) t.chk = c.real;
      }
    }
    return t;
  }
  function ord(m) { var a = m % 10, b = m % 100; return m + (a === 1 && b !== 11 ? 'st' : a === 2 && b !== 12 ? 'nd' : a === 3 && b !== 13 ? 'rd' : 'th'); }
  function isPush(t) { return t.n > MIN && t.n % MIN !== 0; }
  function isSet(t) { return t.n >= MIN && t.n % MIN === 0; }
  /* Option A (native, one Buy X Get Y): double-sided towels are $2 more in a set ($15). "$13 each" only when it's true. */
  function exactRule() { return !!(window.ttDealRule && window.ttDealRule.rule === 'exact'); }
  function eachOk(t) { return exactRule() || t.loSingle; }
  function pushTxt(t) {
    return eachOk(t) ? 'Add ' + t.k + ' more → your ' + ord(t.sets + 1) + ' set of ' + MIN + ' is ' + money0(UNIT) + ' each (save ' + money(t.ns) + ')'
      : 'Add ' + t.k + ' more → save ' + money(t.ns) + ' on your ' + ord(t.sets + 1) + ' set of ' + MIN;
  }
  function nudgeTxt() { return 'Add ' + MIN + ' more, the next set of ' + MIN + ' is ' + (exactRule() ? '' : 'from ') + money0(MIN * UNIT); }
  function dealTxt() { return MIN + ' for ' + money0(MIN * UNIT); }
  /* below 3 towels: what THIS set of 3 costs, added towels assumed single-sided (e.g. "3 for $41" with one double-sided) */
  function firstSetTxt(t) {
    if (!t || !t.n || t.n >= MIN || exactRule()) return dealTxt();
    var off = window.ttDealRule ? window.ttDealRule.off : SINGLE - UNIT;
    return MIN + ' for ' + money0(t.list + (MIN - t.n) * SINGLE - MIN * off);
  }

  /* ---------- render ---------- */
  function slotsHTML(t) {
    var c = counts(picks), s = '';
    uniq(picks).forEach(function (id) {
      var q = c[id], img = P[id] && P[id].img ? '<img src="' + esc(P[id].img) + '" alt="" width="64" height="44" decoding="async">' : '<span class="tt-slot-n"></span>';
      s += '<div class="tt-ptile f">' + img + '<span class="tt-sn">' + esc(nm(id)) + '</span>' + (q > 1 ? '<span class="tt-badge" aria-label="' + q + ' in your cart">×' + q + '</span>' : '') +
        '<button type="button" class="tt-x" data-tt-rm-v="' + id + '" aria-label="Remove ' + (q > 1 ? 'one ' : '') + esc(nm(id)) + '"><span aria-hidden="true">✕</span></button></div>';
    });
    for (var i = t.n; i < MIN; i++) s += '<div class="tt-ptile"><span class="tt-slot-n">' + (i + 1) + '</span><span class="tt-sn">Pick a print</span></div>';
    if (isPush(t)) for (var j = 0; j < t.k; j++) s += '<button type="button" class="tt-ptile tt-ptile-more tt-ptile-push" data-tt-scroll aria-label="' + esc(pushTxt(t)) + '"><span class="tt-slot-n">+</span><span class="tt-sn">' + (j === 0 ? ord(t.sets + 1) + ' set' : 'Pick #' + (t.n + j + 1)) + '</span></button>';
    if (isSet(t)) s += '<button type="button" class="tt-ptile tt-ptile-more" data-tt-scroll aria-label="' + esc(nudgeTxt()) + '"><span class="tt-slot-n">+' + MIN + '</span><span class="tt-sn">Next set ' + (exactRule() ? '' : 'from ') + money0(MIN * UNIT) + '</span></button>';
    return s;
  }
  /* Oct 2026: "+ free shipping" only if completing the first set reaches the free-shipping threshold (D.ship = Theme settings tt_free_ship_min) */
  function freeShipTxt(t) { var s = D.ship || 7500; return (t.list < s && MIN * UNIT >= s) ? ' + free shipping' : ''; }
  function line1(t) {
    if (t.n === 0) return dealTxt() + ' · sets of ' + MIN;
    if (t.off) return t.n + ' towels · ' + money(t.now);
    if (t.n < MIN) return t.n + ' of ' + MIN + ' picked · ' + money(t.now);
    if (isSet(t)) return 'Deal unlocked: ' + t.n + ' towels · ' + money0(t.now);
    return t.n + ' towels · ' + money(t.now);
  }
  function line2(t) {
    if (t.n === 0) return dealTxt() + ' · mix & match in sets of ' + MIN + ' · free US shipping on ' + SHIP_N + '+ towels or ' + money0(D.ship || 7500) + '+';
    if (t.off) return 'Some towels aren\'t in the deal. <a href="' + CART_URL + '">View cart</a>';
    if (t.n < MIN) return 'Add ' + (MIN - t.n) + ' more → ' + firstSetTxt(t) + freeShipTxt(t);
    if (isSet(t)) return '<span class="tt-ok">You save ' + money(t.save) + ' · ' + nudgeTxt() + '</span>';
    return '<b class="tt-push">' + esc(pushTxt(t)) + '</b>';
  }
  function coLabel(t) {
    if (!t.n) return 'Check out';
    if (t.n < MIN || t.off) return 'Check out · ' + money(t.now) + ' →';
    return 'Check out · ' + t.n + ' towels · ' + money0(t.now) + ' →';
  }
  /* tray head (above the Check out button): what to do next */
  function trayL1(t) {
    if (t.off) return t.n + ' towels · ' + money(t.now);
    if (t.n < MIN) return 'Add ' + (MIN - t.n) + ' more → ' + firstSetTxt(t) + freeShipTxt(t);
    if (isSet(t)) return 'Deal unlocked: ' + t.n + ' towels · ' + money0(t.now) + ' · you save ' + money(t.save);
    return pushTxt(t);
  }
  function trayL2(t) {
    if (t.off) return pending ? 'Updating your deal price…' : 'Some towels aren\'t priced as a set yet. Check your cart.';
    if (t.n < MIN) return t.n + ' of ' + MIN + ' picked · ' + money(t.now);
    if (isSet(t)) return nudgeTxt();
    return 'Now ' + t.n + ' towels · ' + money(t.now);
  }
  /* Oct 6 2026: "Free shipping included" next to the total once 3+ towels are picked (Economy is free on US orders at or above D.ship, Theme settings tt_free_ship_min) */
  var FS_TXT = '\u2713 Free shipping included';
  /* Oct 16 2026: Economy is also free on 6+ towels (automatic discount, min quantity SHIP_N) */
  var SHIP_N = D.ship_n || 6;
  /* whole-cart total / item count (non-towel items count toward both, like the shipping discount and the $75 rate) */
  function cTot(t) { return Math.max(t.now, (C && !pending && C.total_price) || 0); }
  function cN(t) { return Math.max(t.n, (C && !pending && C.item_count) || 0); }
  function fsOn(t) { return t.n >= MIN && !t.off && (cTot(t) >= (D.ship || 7500) || cN(t) >= SHIP_N) && !(window.Shopify && Shopify.country && Shopify.country !== 'US'); }
  /* Oct 8 2026: under the free-shipping minimum the tray says what shipping costs: "+ $6.50 Economy shipping · free on $75+" ($6.50 since Oct 13 2026).
     ECON is hard-coded (Shopify doesn't expose rates to the theme): keep in sync with Settings > Shipping > Economy and
     snippets/tt-freeship-line.liquid (fs_econ). US only; both modes (B2G1 inherits render). */
  var ECON = D.econ || 650;
  function shipNote() { return '+ ' + money(ECON) + ' Economy shipping · free on ' + SHIP_N + '+ towels or ' + money0(D.ship || 7500) + '+'; }
  function shipUnder(t) { return t.n > 0 && !t.off && cTot(t) < (D.ship || 7500) && cN(t) < SHIP_N && !(window.Shopify && Shopify.country && Shopify.country !== 'US'); }

  /* status line, desktop summary title, add toast (Oct 7 2026: functions so the Buy 2, Get 1 Free mode can swap the copy) */
  function statusTxt(t) {
    return !t.n ? 'Pick ' + MIN + ' prints: <b>' + dealTxt() + '</b>, mix &amp; match in sets of ' + MIN + '.'
      : (isSet(t) && !t.off) ? '<span class="tt-ok">' + nudgeTxt() + '.</span>' : line2(t);
  }
  function sumTitle(t) { return isSet(t) ? 'Deal unlocked' : isPush(t) ? 'Add ' + t.k + ' more for set ' + (t.sets + 1) : t.n ? (MIN - t.n) + ' more → ' + firstSetTxt(t) : 'Pick ' + MIN + ' prints'; }
  function pickToast(n, t) {
    return n === MIN ? 'Deal unlocked! ' + MIN + ' for ' + money0(t.now) + ' 🎉' : n < MIN ? 'Added! ' + (MIN - n) + ' more → ' + firstSetTxt(t)
      : isSet(t) ? 'Set ' + t.sets + ' complete! ' + n + ' towels · ' + money0(t.now) + ' 🎉'
      : eachOk(t) ? 'Added · ' + t.k + ' more makes your ' + ord(t.sets + 1) + ' set ' + money0(UNIT) + ' each' : 'Added · ' + t.k + ' more saves ' + money(t.ns) + ' on your ' + ord(t.sets + 1) + ' set';
  }

  function render() {
    var t = totals(), c = counts(picks);
    $$('[data-tt-slots]').forEach(function (e) {
      e.innerHTML = slotsHTML(t);
      if (grew && e.scrollWidth > e.clientWidth) e.scrollLeft = e.scrollWidth;
    });
    grew = false;
    $$('[data-tt-l1]').forEach(function (e) { e.textContent = line1(t); });
    $$('[data-tt-status]').forEach(function (e) {
      e.innerHTML = statusTxt(t);
    });
    $$('[data-tt-meter]').forEach(function (e) { e.style.width = (t.n === 0 ? 0 : isSet(t) ? 100 : (t.n % MIN) / MIN * 100) + '%'; });
    var st = $('[data-tt-sum-title]');
    if (st) st.textContent = sumTitle(t);
    var w = $('[data-tt-was]'), nw = $('[data-tt-now]'), sv = $('[data-tt-save]');
    if (w) w.textContent = t.save > 0 ? money(t.list) : '';
    if (nw) nw.textContent = money(t.now);
    if (sv) sv.textContent = t.save > 0 ? 'You save ' + money(t.save) + (fsOn(t) ? ' · Free shipping included' : '') : '';
    $$('[data-tt-checkout]').forEach(function (b) { if (!b.classList.contains('is-busy')) b.textContent = coLabel(t); b.classList.toggle('is-off', t.n === 0); });
    /* tray */
    var tray = document.getElementById('tt-tray');
    if (tray) {
      $('[data-tt-tray-empty]', tray).hidden = t.n > 0;
      $('[data-tt-tray-full]', tray).hidden = t.n === 0;
      var l1 = $('[data-tt-th-l1]', tray), l2 = $('[data-tt-th-l2]', tray), head = $('[data-tt-co-head]', tray);
      if (l1) l1.textContent = trayL1(t);
      if (l2) { l2.innerHTML = shipUnder(t) ? '<span class="tt-fs-out" data-tt-fs>' + esc(shipNote()) + '</span>' : (fsOn(t) ? '<span class="tt-fs-in" data-tt-fs>' + FS_TXT + '</span> · ' : '') + esc(trayL2(t)); l2.classList.toggle('tt-ok', isSet(t) && !t.off && !shipUnder(t)); }
      if (head) {
        /* complete sets: tap the head to check out. 4/5, 7/8 ...: the head is the push and taps through to the prints */
        var go = isSet(t) && !t.off, push = isPush(t) && !t.off;
        head.classList.toggle('is-go', go); head.classList.toggle('is-push', push);
        head.disabled = !go && !push;
        head.setAttribute('aria-label', trayL1(t) + '. ' + (shipUnder(t) ? shipNote() + '. ' : fsOn(t) ? 'Free shipping included. ' : '') + trayL2(t) + (go ? '. Tap to check out' : push ? '. Tap to pick more prints' : ''));
      }

    }
    /* cards: "+ Add" when not picked; a − / count / + stepper once picked */
    $$('.tt-card[data-variant-id]').forEach(function (card) {
      if (card.hasAttribute('data-soldout')) return;
      var id = card.getAttribute('data-variant-id'), q = c[id] || 0, b = $('.tt-add', card), qb = $('.tt-qty', card), sp = $('.tt-stp', card);
      card.classList.toggle('is-sel', q > 0);
      if (qb) qb.textContent = q > 1 ? '×' + q : '✓';
      if (b) b.hidden = q > 0;
      if (sp) {
        sp.hidden = q === 0;
        var n = $('.tt-st-n', sp); if (n) n.textContent = q + ' added';
        var m = $('[data-tt-dec]', sp); if (m) m.setAttribute('aria-label', q > 1 ? 'Remove one ' + nm(id) : 'Remove ' + nm(id));
      }
    });
    syncTray();
  }
  var toastT;
  function toast(m) { var e = $('[data-tt-toast]'); if (!e) return; e.textContent = m; e.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { e.classList.remove('on'); }, 2000); }
  function msg(h) { $$('[data-tt-msg]').forEach(function (e) { e.innerHTML = h || ''; }); }
  function toBuild() { var b = document.getElementById('build'); if (b) b.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); }
  function selectTab(tab) {
    $$('[data-tt-tab]').forEach(function (x) { var on = x === tab; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
    var all = document.getElementById('tt-panel-all'); if (all) all.hidden = true;
    var mb = $('[data-tt-all]'); if (mb) mb.hidden = false;
  }
  function markSoldOut(id) {
    if (P[id]) P[id].so = 1;
    $$('.tt-card[data-variant-id="' + id + '"]').forEach(function (card) {
      card.setAttribute('data-soldout', ''); card.classList.add('is-soldout'); card.classList.remove('is-sel');
      $$('[data-tt-add],[data-tt-inc],[data-tt-dec]', card).forEach(function (b) { b.disabled = true; b.removeAttribute('data-tt-add'); b.removeAttribute('data-tt-inc'); b.removeAttribute('data-tt-dec'); });
      var sp = $('.tt-stp', card); if (sp) sp.hidden = true;
      var b = $('.tt-add', card); if (b) { b.hidden = false; b.textContent = 'Sold out'; b.removeAttribute('aria-label'); }
    });
  }

  /* ---------- cart (Shopify AJAX API) ---------- */
  var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function req(path, body) {
    var o = body ? { method: 'POST', headers: H, credentials: 'same-origin', body: JSON.stringify(body) } : { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    return fetch(ROOT + path, o).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, j: j }; }); });
  }
  function getCart() { return req('cart.js').then(function (r) { if (!r.ok || !r.j || !r.j.items) throw new Error('cart'); C = r.j; return C; }); }
  function withSec(b) { b.sections = SEC; b.sections_url = location.pathname; return b; }
  function applySections(j) {
    var s = j && j.sections, box = document.getElementById(SEC);
    if (!s || !s[SEC] || !box) return;
    var d = new DOMParser().parseFromString(s[SEC], 'text/html').querySelector('.shopify-section');
    if (d) box.innerHTML = d.innerHTML;
  }
  /* deal towels in a cart: {m: variant -> qty, order: oldest first}. Kitchen towels not listed on the page get a P entry from the cart line. */
  function deal(cart) {
    var m = {}, ord = [];
    (cart.items || []).slice().reverse().forEach(function (i) {
      if (i.product_type !== TYPE) return;
      var v = String(i.variant_id);
      if (!(v in m)) { m[v] = 0; ord.push(v); }
      m[v] += i.quantity;
      if (!P[v]) P[v] = { t: String(i.product_title).replace(/ \(Double[ -]Sided\)/i, ''), ft: i.product_title, p: i.original_price, img: i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '', x: 1 };
    });
    return { m: m, order: ord };
  }
  function reconcile() {
    if (!C) return;
    var d = deal(C), left = {}, out = [];
    Object.keys(d.m).forEach(function (v) { left[v] = d.m[v]; });
    picks.forEach(function (v) { if (left[v] > 0) { out.push(v); left[v]--; } });
    d.order.forEach(function (v) { while (left[v] > 0) { out.push(v); left[v]--; } });
    picks = out;
  }
  function publishCart() {
    try { if (C && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tt-deal', cartData: C }); } catch (e) {}
  }
  /* tag the cart once so orders from this page can be attributed (cart attribute only, never adds items) */
  function tagCart() {
    if (!C || (C.attributes && C.attributes._landing) || !deal(C).order.length) return Promise.resolve();
    return req('cart/update.js', { attributes: { _landing: D.landing || 'towel-deal' } }).then(function (r) { if (r.ok && r.j.items) C = r.j; });
  }
  /* Oct 7 2026 (bug fix): the deal page the shopper is ON sets the cart's active offer. Sets-of-3 pages (/pages/towel-deal):
     on load, after every add and before checkout, remove any Buy 2, Get 1 code (a code containing "B2G1", e.g. TTB2G1X7;
     other codes are kept) and tag the cart _tt_offer = sets3 / _landing = this page, so the SMART pricing and the sets-of-3
     cart messaging apply and the two offers never mix. Also drops a B2G1 /discount link cookie (discount_code) if JS can see it.
     The B2G1 page (D.mode = 'b2g1') replaces this with ensureCode (see the block near the end). No request when nothing to do.
     Tested Oct 7: a code put on an EMPTY cart (old B2G1 page load, or a /discount link) and then removed with update.js while the
     cart has items comes back at checkout. Removing it while the cart is empty sticks, so with items in the cart this clears the
     cart, removes the code, then adds the same lines back (variant, quantity, properties, selling plan). The lines are kept in
     sessionStorage for 10 minutes and put back on the next load if the page is left mid-swap. */
  function dropB2Cookie() {
    try {
      if (!/(?:^|;\s*)discount_code=[^;]*B2G1/i.test(document.cookie)) return;
      var h = location.hostname, ds = ['', '; domain=' + h, '; domain=.' + h.replace(/^www\./, '')];
      ds.forEach(function (d) { document.cookie = 'discount_code=; Max-Age=0; path=/' + d; });
    } catch (e) {}
  }
  /* Oct 8 2026: re-tested: once a code has been put on an EMPTY cart, clear + remove + re-add no longer keeps it off at checkout
     (it came back at checkout every time, with or without other codes kept). A NEW cart is clean, so when a B2G1 code has to
     come off, the old cart is emptied, its cookie dropped, and the lines, attributes, note and the other codes (SHIPFREE, ...)
     go onto a fresh cart. Falls back to the old clear + remove + re-add if the cart cookie can't be dropped. */
  function dropCartCookie() {
    try {
      var h = location.hostname, ds = ['', '; domain=' + h, '; domain=.' + h.replace(/^www\./, '')];
      ds.forEach(function (d) { document.cookie = 'cart=; Max-Age=0; path=/' + d; });
      return !/(?:^|;\s*)cart=/.test(document.cookie);
    } catch (e) { return false; }
  }
  var SWAP_KEY = 'tt_offer_swap';
  function swapGet() { try { var x = JSON.parse(sessionStorage.getItem(SWAP_KEY) || 'null'); return x && Date.now() - x.t < 600000 ? x.items : null; } catch (e) { return null; } }
  function swapSet(items) { try { if (items) sessionStorage.setItem(SWAP_KEY, JSON.stringify({ t: Date.now(), items: items })); else sessionStorage.removeItem(SWAP_KEY); } catch (e) {} }
  function readd(items) {
    if (!items || !items.length) return Promise.resolve();
    return req('cart/add.js', { items: items }).then(function (r) {
      if (r.ok) return;
      /* e.g. one line out of stock now: add the rest one by one */
      return items.reduce(function (p, it) { return p.then(function () { return req('cart/add.js', { items: [it] }); }); }, Promise.resolve());
    });
  }
  function ensureSets3() {
    dropB2Cookie();
    return (C ? Promise.resolve(C) : getCart()).then(function (c) {
      var land = D.landing || 'towel-deal', tags = { _tt_offer: 'sets3', _landing: land };
      var left = swapGet();
      if (left && !c.item_count) return readd(left).then(function () { swapSet(null); return req('cart/update.js', { attributes: tags }); }).then(getCart).then(function () { publishCart(); });
      var codes = (c.discount_codes || []).map(function (d) { return String(d.code); });
      var keep = codes.filter(function (x) { return !/B2G1/i.test(x); }), hasB2 = keep.length !== codes.length;
      var a = c.attributes || {};
      var retag = (c.item_count > 0 || hasB2) && (a._tt_offer !== 'sets3' || a._landing !== land);
      if (!hasB2 && !retag) return;
      if (!hasB2) return req('cart/update.js', { attributes: tags }).then(function (r) { if (r.ok && r.j && r.j.items) C = r.j; });
      var at = {}; Object.keys(a).forEach(function (k) { at[k] = a[k]; }); at._tt_offer = tags._tt_offer; at._landing = tags._landing;
      var b = { attributes: at, discount: keep.join(',') }; if (c.note) b.note = c.note;
      if (!c.item_count) return req('cart/clear.js', {}).then(function () { dropCartCookie(); return req('cart/update.js', b); }).then(function (r) { if (r.ok && r.j && r.j.items) C = r.j; });
      var items = c.items.slice().reverse().map(function (i) {
        var it = { id: i.variant_id, quantity: i.quantity };
        if (i.properties && Object.keys(i.properties).length) it.properties = i.properties;
        if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) it.selling_plan = i.selling_plan_allocation.selling_plan.id;
        return it;
      });
      swapSet(items);
      return req('cart/clear.js', {}).then(function () {
        if (dropCartCookie()) return readd(items).then(function () { return req('cart/update.js', b); });
        return req('cart/update.js', b).then(function () { return readd(items); });
      }).then(function () { swapSet(null); return getCart(); }).then(function () { publishCart(); });
    });
  }
  /* all cart work runs one at a time, in tap order */
  function enqueue(fn) {
    pending++;
    chain = chain.then(fn).catch(function (e) { C = null; if (e && e.note) msg(e.note); else msg('Something went wrong updating your cart. <a href="' + CART_URL + '">View cart</a>'); }).then(function () {
      if (--pending === 0) return settle();
    });
    return chain;
  }
  function settle() {
    return (C ? Promise.resolve(C) : getCart()).then(function () {
      if (pending) return;
      return ensureSets3().then(fixOrder).then(function () { reconcile(); render(); publishCart(); return tagCart(); });
    }).catch(function () { render(); });
  }
  /* add.js with stock checks; a 422 may still add part of a multi-item request, so undo exactly what this request added */
  function opAdd(items) {
    var snap = null, multi = items.length > 1 || items[0].quantity > 1;
    return (multi ? getCart().then(function (c) { snap = deal(c).m; }) : Promise.resolve()).then(function () {
      return req('cart/add.js', withSec({ items: items }));
    }).then(function (r) {
      C = null;
      if (r.ok) { applySections(r.j); return true; }
      return undoAdd(items, snap, r.j || {}).then(function () { return false; });
    });
  }
  function undoAdd(items, snap, err) {
    var text = String(err.description || err.message || '');
    var stock = /sold out|can't add|can only add|only \d+|availab|in stock|in your cart/i.test(text);
    return getCart().then(function (after) {
      var a = deal(after).m, fix = [], bad = null;
      if (snap) items.forEach(function (x) { var v = String(x.id), got = (a[v] || 0) - (snap[v] || 0); if (got > 0) fix.push([v, got]); });
      items.forEach(function (x) { var v = String(x.id); if (P[v] && text.indexOf(P[v].ft) > -1 && (!bad || P[v].ft.length > P[bad].ft.length)) bad = v; });
      if (!bad) items.forEach(function (x) { var v = String(x.id); if (!bad && (!snap || (a[v] || 0) - (snap[v] || 0) < x.quantity)) bad = v; });
      return fix.reduce(function (p, f) { return p.then(function () { return lower(f[0], f[1]); }); }, Promise.resolve()).then(function () {
        var note;
        if (bad && stock) {
          var have = deal(C || after).m[bad] || 0;
          if (have > 0) note = 'Sorry, only ' + have + ' ' + esc(nm(bad)) + ' left, and ' + (have > 1 ? 'they\'re' : 'it\'s') + ' already in your cart. Pick another?';
          else { note = 'Sorry, ' + esc(nm(bad)) + ' just sold out. Pick another?'; markSoldOut(bad); }
        } else note = esc(text || 'Sorry, that towel couldn\'t be added.') + ' <a href="' + CART_URL + '">View cart</a>';
        msg(note);
      });
    });
  }
  /* remove n units of a variant: /cart/change.js on its line key(s) (the deal can split one variant over two lines) */
  function lower(v, n) {
    if (n <= 0) return Promise.resolve();
    return (C ? Promise.resolve(C) : getCart()).then(function (c) {
      var line = null;
      (c.items || []).forEach(function (i) { if (String(i.variant_id) === String(v)) line = i; });
      if (!line) return;
      var take = Math.min(line.quantity, n);
      return req('cart/change.js', withSec({ id: line.key, quantity: line.quantity - take })).then(function (r) {
        if (!r.ok || !r.j || !r.j.items) { C = null; var e = new Error('change'); e.note = 'Sorry, we couldn\'t remove ' + esc(nm(v)) + '. <a href="' + CART_URL + '">View cart</a>'; throw e; }
        C = r.j; applySections(r.j);
        return lower(v, n - take);
      });
    });
  }

  /* ---------- actions (optimistic UI, then the cart call). No cap: every add is one more towel. ---------- */
  function pick(v) {
    picks.push(v); grew = true; msg(''); render();
    var n = picks.length;
    var t = totals();
    toast(pickToast(n, t));
    enqueue(function () { return opAdd([{ id: +v, quantity: 1 }]); });
  }
  /* remove ONE towel of a print (the newest one) */
  function unpickOne(v) {
    var i = picks.lastIndexOf(v); if (i < 0) return;
    picks.splice(i, 1); msg(''); render();
    var n = picks.length;
    toast('Removed ' + nm(v) + (n && n < MIN ? ' · ' + (MIN - n) + ' more → ' + firstSetTxt(totals()) : ''));
    enqueue(function () { return lower(v, 1); });
  }
  /* presets are 3-towel starters added ON TOP of existing picks; prints already picked are not added twice */
  function applyPreset(key) {
    var p = D.presets[key]; if (!p) { toBuild(); return; }
    var ids = p.ids.filter(function (id) { return P[id] && !P[id].so; });
    var c0 = counts(picks), fresh = ids.filter(function (id) { return !c0[id]; });
    if (!fresh.length) { toast(p.t + ' is already in your picks'); toBuild(); return; }
    picks = picks.concat(fresh); grew = true; msg(''); render(); toBuild();
    var n = picks.length;
    toast(p.t + ' added' + (fresh.length < ids.length ? ' (' + fresh.length + ' new)' : '') + ' · ' + n + ' towels · ' + money(totals().now));
    /* diff against the real cart inside the queue, so nothing is double-added */
    enqueue(function () {
      return getCart().then(function (c) {
        var have = deal(c).m, adds = [];
        fresh.forEach(function (v) { if (!have[v]) adds.push({ id: +v, quantity: 1 }); });
        return adds.length ? opAdd(adds) : true;
      });
    });
  }
  (function initPreset() {
    if (!presetKey) { $$('[data-tt-preset-label]').forEach(function (b) { b.hidden = true; }); return; }
    $$('[data-tt-preset-card]').forEach(function (c) { c.hidden = c.getAttribute('data-tt-preset-card') !== presetKey; });
    if (presetKey !== order[0]) $$('[data-tt-preset-label]').forEach(function (b) { b.textContent = 'Grab ' + D.presets[presetKey].t.replace(/^The /, 'the ') + ' in one tap'; });
  })();

  function busyBtn(b, on) { if (!b) return; b.classList.toggle('is-busy', on); b.setAttribute('aria-busy', on ? 'true' : 'false'); if (!on) render(); }
  function checkout(btn) {
    if (!picks.length && !pending) { toBuild(); return; }
    if (btn.classList.contains('is-busy')) return;
    busyBtn(btn, true);
    btn.textContent = 'Opening checkout…';
    /* ok unless the deal towels cost MORE than the sets-of-3 total (a towel the discount missed) */
    function priced(c) {
      var r = window.ttCartSets ? window.ttCartSets(c) : { n: 0, real: 0, total: 0 };
      return { k: r.n, ok: r.n < MIN || r.real <= r.total + 1 };
    }
    chain.then(getCart).then(function (c) {
      var p = priced(c);
      if (!c.item_count) { busyBtn(btn, false); reconcile(); render(); toBuild(); return; }
      /* priced above the sets-of-3 total: run the double-sided re-order guard (assets/tt-cart-fix.js) and WAIT for it */
      var fixed = p.ok || !window.ttDealFix ? Promise.resolve(c) : window.ttDealFix(c).then(function (c2) { return c2 && c2.items ? c2 : getCart(); });
      return fixed.then(function (c2) {
        C = c2; var p2 = priced(c2);
        /* safety net only if a discount is STILL not applied after the fix */
        if (!p2.ok && window.console) console.warn('[tt-deal] deal not applied as expected after fix', p2.k);
        return ensureSets3().then(tagCart).then(function () { location.href = p2.ok ? ROOT + 'checkout' : CART_URL; });
      });
    }).catch(function () { busyBtn(btn, false); msg('Something went wrong. Please try again or <a href="' + CART_URL + '">view your cart</a>.'); });
  }

  /* ---------- events ---------- */
  function onClick(e) {
    var t = e.target, card, id;
    var add = t.closest('[data-tt-add],[data-tt-inc],[data-tt-dec]');
    if (add) {
      card = add.closest('.tt-card'); id = card && card.getAttribute('data-variant-id');
      if (!id || card.hasAttribute('data-soldout') || !P[id] || P[id].so) return;
      var q = counts(picks)[id] || 0;
      /* "+ Add" / stepper "+": add one. Stepper "−": remove one. Tapping the photo of a picked card removes one (a toggle at 1). */
      if (add.hasAttribute('data-tt-dec') || (add.classList.contains('tt-im') && q > 0)) unpickOne(id);
      else pick(id);
      return;
    }
    var rm = t.closest('[data-tt-rm-v]');
    if (rm) { unpickOne(rm.getAttribute('data-tt-rm-v')); return; }
    var pr = t.closest('[data-tt-preset]');
    if (pr) { applyPreset(pr.getAttribute('data-tt-preset') || presetKey); return; }
    var tab = t.closest('[data-tt-tab]');
    if (tab) { selectTab(tab); return; }
    if (t.closest('[data-tt-all]')) {
      var all = document.getElementById('tt-panel-all'); if (!all) return;
      $$('[data-tt-tab]').forEach(function (x) { x.setAttribute('aria-selected', 'false'); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = true; });
      all.hidden = false; t.closest('[data-tt-all]').hidden = true; return;
    }
    var gt = t.closest('[data-tt-goto-tab]');
    if (gt) {
      e.preventDefault();
      var label = gt.getAttribute('data-tt-goto-tab').toLowerCase();
      var tb = $$('[data-tt-tab]').filter(function (x) { return x.getAttribute('data-tt-tab').toLowerCase().indexOf(label) > -1; })[0];
      if (tb) selectTab(tb);
      toBuild(); return;
    }
    if (t.closest('[data-tt-scroll]')) { e.preventDefault(); toBuild(); return; }
    var co = t.closest('[data-tt-checkout]');
    if (co) { checkout(co); return; }
    var hd = t.closest('[data-tt-co-head]');
    if (hd) { if (hd.classList.contains('is-go')) checkout($('[data-tt-co-main]') || hd); else if (hd.classList.contains('is-push')) toBuild(); return; }

    var ca = t.closest('[data-tt-cart]');
    if (ca && pending) { e.preventDefault(); chain.then(function () { location.href = CART_URL; }); }
  }
  var BUILDER = '[data-tt-add],[data-tt-inc],[data-tt-dec],[data-tt-rm-v],[data-tt-preset]';
  document.addEventListener('click', function (e) {
    /* until the first cart sync lands, hold builder taps so a towel already in the cart is never added twice */
    if (!synced && e.target.closest && e.target.closest(BUILDER)) { var tg = e.target; ready.then(function () { onClick({ target: tg, preventDefault: function () {} }); }); return; }
    onClick(e);
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-tt-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = $$('[data-tt-tab]'), i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var nx = tabs[(i + tabs.length) % tabs.length]; selectTab(nx); nx.focus(); e.preventDefault();
  });

  /* ---------- sticky tray: hidden while the hero CTAs are on screen and nothing is picked ---------- */
  var heroVisible = false, sumVisible = false, trayEl = document.getElementById('tt-tray'), mq = matchMedia('(max-width:899px)');
  function syncTray() {
    if (!trayEl) return;
    /* Oct 20 2026 (lp-oct20): on the Buy 2, Get 1 page the sticky bar only appears once a towel is picked */
    trayEl.classList.toggle('is-hidden', (D.mode === 'b2g1' && picks.length === 0) || (heroVisible && picks.length === 0) || (!mq.matches && (sumVisible || picks.length === 0)));
    var pb = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--tt-pbar'), 10) || 0;
    document.body.style.paddingBottom = mq.matches ? (trayEl.offsetHeight + pb + 8) + 'px' : '';
  }
  var ctas = $('[data-tt-hero-ctas]');
  if (ctas && 'IntersectionObserver' in window) {
    heroVisible = true;
    new IntersectionObserver(function (en) { heroVisible = en[0].isIntersecting; syncTray(); }).observe(ctas);
  }
  /* desktop (900px+): the sidebar summary has the Check out button; when it scrolls out of view the slim tray takes over */
  var sumEl = $('.tt-summary');
  if (sumEl && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sumVisible = en[0].isIntersecting; syncTray(); }, { rootMargin: '-80px 0px -40px 0px' }).observe(sumEl);
  }
  if (mq.addEventListener) mq.addEventListener('change', syncTray);
  window.addEventListener('resize', function () { syncTray(); });
  document.addEventListener('tt:measure', function () { syncTray(); });
  $$('a[data-tt-cart]').forEach(function (a) { a.href = CART_URL; });
  /* a page restored from the browser cache can show an old header count: re-render the bubble only when it disagrees with the cart */
  function fixBubble() {
    var box = document.getElementById(SEC); if (!box || !C) return;
    var b = $('.cart-count-bubble span[aria-hidden]', box), shown = b ? parseInt(b.textContent, 10) || 0 : 0;
    if (shown === C.item_count || (C.item_count >= 100 && b)) return;
    fetch(ROOT + '?sections=' + SEC + '&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (j) { applySections({ sections: j }); }).catch(function () {});
  }
  /* assets/tt-cart-fix.js: re-orders double-sided lines only when the deal towels are priced above the sets-of-3 total */
  function fixOrder() { return C && window.ttDealFix ? window.ttDealFix(C).then(function (c) { if (c && c.items) C = c; }) : Promise.resolve(); }
  function resync() { C = null; return getCart().then(ensureSets3).then(fixOrder).then(function () { reconcile(); synced = true; render(); fixBubble(); }).catch(function () { synced = true; render(); }); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) { $$('[data-tt-checkout]').forEach(function (b) { b.classList.remove('is-busy'); }); resync(); } });

  /* ---------- Buy 2, Get 1 Free mode (Oct 7 2026; templates/page.buy-2-get-1.json, builder setting "Offer" = b2g1) ----------
     In every 3 towels the lowest-priced one is free, repeating (6 towels = 2 free); single- and double-sided mix. Shopify's
     native Buy X Get Y code (D.code) does the pricing at checkout; this page puts it on the cart with POST /cart/update.js
     {discount} on load and again before checkout, and tags the cart (_tt_offer = b2g1) so the cart popup / cart page show
     B2G1 messaging. The sets-of-3 re-order guard (ttDealFix) never runs here. Free shipping is NOT part of the offer: the tray
     shows progress to the store-wide threshold (D.ship = Theme settings > Towel deal > Free US shipping from). The default
     sets-of-3 mode (/pages/towel-deal) never enters this block. */
  var B2 = D.mode === 'b2g1', CODE = D.code || '';
  if (B2) {
    var SHIP = D.ship || 7500;
    var b2calc = function (pr) {
      var u = pr.map(function (p, i) { return { p: p, i: i }; }).sort(function (a, b) { return b.p - a.p || a.i - b.i; });
      var n = u.length, nf = Math.floor(n / MIN), list = 0, save = 0, free = [];
      u.forEach(function (x, j) { list += x.p; free[x.i] = j >= n - nf; if (free[x.i]) save += x.p; });
      return { n: n, list: list, total: list - save, save: save, nf: nf, k: MIN - (n % MIN), free: free };
    };
    var priceOf = function (id) { return P[id] ? P[id].p : SINGLE; };
    var us = function () { return !(window.Shopify && Shopify.country && Shopify.country !== 'US'); };
    totals = function () {
      var r = b2calc(picks.map(priceOf));
      var t = { n: r.n, list: r.list, now: r.total, save: r.save, sets: r.nf, k: r.k, ns: SINGLE, lo: 0, loSingle: true, real: false, off: false, chk: null };
      if (C && !pending) {
        var pr = [], real = 0;
        (C.items || []).filter(function (i) { return i.product_type === TYPE && !i.selling_plan_allocation; }).reverse().forEach(function (i) { real += i.final_line_price; for (var q = 0; q < i.quantity; q++) pr.push(i.original_price); });
        if (pr.length === t.n) {
          var c = b2calc(pr);
          t.list = c.list; t.now = c.total; t.save = c.save; t.real = true;
          t.off = t.n >= MIN && real > c.total + 1; /* the code isn't giving the free towel(s) (code inactive or removed) */
          if (Math.abs(real - c.total) > 1) t.chk = real;
        }
      }
      return t;
    };
    dealTxt = function () { return 'Buy 2, get 1 free'; };
    nudgeTxt = function () { return 'Add ' + MIN + ' more, get another one free'; };
    pushTxt = function (t) { return 'Add ' + t.k + ' more → get ' + (t.sets ? 'another one' : '1') + ' free'; };
    firstSetTxt = function () { return 'get 1 free'; };
    eachOk = function () { return true; };
    freeShipTxt = function () { return ''; };
    var shipLeft = function (t) { return us() && cTot(t) < SHIP && cN(t) < SHIP_N ? (SHIP_N - cN(t)) + ' more towel' + (SHIP_N - cN(t) > 1 ? 's' : '') + ' or ' + money(SHIP - cTot(t)) + ' for free shipping' : ''; };
    fsOn = function (t) { return t.n > 0 && (cN(t) >= SHIP_N || (!t.off && cTot(t) >= SHIP)) && us(); };
    line1 = function (t) {
      if (t.n === 0) return dealTxt() + ' · mix any prints';
      if (t.off || t.n < MIN) return t.n + ' towel' + (t.n > 1 ? 's' : '') + ' · ' + money(t.now);
      return t.n + ' towels · ' + t.sets + ' free · ' + money(t.now);
    };
    line2 = function (t) {
      if (t.n === 0) return dealTxt() + ' · mix any prints';
      if (t.off) return 'Buy 2, get 1 free isn\'t applied yet. <a href="' + CART_URL + '">View cart</a>';
      if (t.n < MIN) return 'Add ' + (MIN - t.n) + ' more → get 1 free';
      if (isSet(t)) return '<span class="tt-ok">You save ' + money(t.save) + ' · ' + nudgeTxt() + '</span>';
      return '<b class="tt-push">' + esc(pushTxt(t)) + '</b>';
    };
    /* Oct 13 audit fix 1: at 2, 5, 8 ... towels the next towel is free, so the main tray button leads back to the builder
       ("Pick your FREE towel →") instead of checkout; a small secondary button still checks out. B2G1 page only. */
    var freeNext = function (t) { return t.n > 0 && !t.off && t.n % MIN === MIN - 1; };
    coLabel = function (t) {
      if (!t.n) return 'Check out';
      if (freeNext(t)) return 'Pick your FREE towel →';
      if (t.n < MIN || t.off) return 'Check out · ' + money(t.now) + ' →';
      return 'Check out · ' + t.n + ' towels · ' + money(t.now) + ' →';
    };
    /* Oct 20 2026 (lp-oct20): sticky bar progress "1 of 3 picked" / "2 of 3 picked – next one FREE" / "3rd towel FREE ✓", repeating every 3 */
    trayL1 = function (t) {
      if (t.off) return t.n + ' towels · ' + money(t.chk || t.now);
      var m = t.n % MIN, fr = Math.floor(t.n / MIN);
      if (m === 1) return '1 of ' + MIN + ' picked' + (fr ? ' · ' + fr + ' FREE so far' : '');
      if (m === 2) return '2 of ' + MIN + ' picked – next one FREE';
      return '3rd towel FREE ✓' + (fr > 1 ? ' · ' + fr + ' FREE' : '');
    };
    trayL2 = function (t) {
      if (t.off) return pending ? 'Updating your price…' : 'Buy 2, get 1 free isn\'t applied yet. Check your cart.';
      var a = t.n < MIN ? t.n + ' of ' + MIN + ' picked · ' + money(t.now) : (t.save > 0 ? 'You save ' + money(t.save) : t.n + ' towels · ' + money(t.now));
      var s = shipLeft(t);
      return s ? a + ' · ' + s : a;
    };
    statusTxt = function (t) {
      if (!t.n) return 'Pick any ' + MIN + ' prints: <b>' + dealTxt() + '</b>, every 3rd towel is FREE.';
      return (isSet(t) && !t.off) ? '<span class="tt-ok">' + t.sets + ' free · ' + nudgeTxt() + '.</span>' : line2(t);
    };
    sumTitle = function (t) { return isSet(t) ? t.sets + ' free towel' + (t.sets > 1 ? 's' : '') : isPush(t) ? 'Add ' + t.k + ' more for another free one' : t.n ? (MIN - t.n) + ' more → get 1 free' : 'Pick any ' + MIN + ' prints'; };
    pickToast = function (n, t) {
      return n < MIN ? 'Added! ' + (MIN - n) + ' more → get 1 free' : isSet(t) ? t.sets + ' free! ' + n + ' towels · ' + money(t.now) + ' 🎉' : 'Added · ' + t.k + ' more gets another one free';
    };
    /* picked-towel tiles: the free one(s) (lowest-priced) get a FREE tag */
    slotsHTML = function (t) {
      var c = counts(picks), s = '', r = b2calc(picks.map(priceOf)), fr = {};
      picks.forEach(function (id, i) { if (r.free[i]) fr[id] = (fr[id] || 0) + 1; });
      uniq(picks).forEach(function (id) {
        var q = c[id], f = fr[id] || 0, img = P[id] && P[id].img ? '<img src="' + esc(P[id].img) + '" alt="" width="64" height="44" decoding="async">' : '<span class="tt-slot-n"></span>';
        s += '<div class="tt-ptile f' + (f ? ' is-free' : '') + '">' + img + '<span class="tt-sn">' + esc(nm(id)) + '</span>' + (q > 1 ? '<span class="tt-badge" aria-label="' + q + ' in your cart">×' + q + '</span>' : '') +
          (f ? '<span class="tt-free-tag">' + (q > 1 ? f + ' free' : 'FREE') + '</span>' : '') +
          '<button type="button" class="tt-x" data-tt-rm-v="' + id + '" aria-label="Remove ' + (q > 1 ? 'one ' : '') + esc(nm(id)) + '"><span aria-hidden="true">✕</span></button></div>';
      });
      for (var i = t.n; i < MIN; i++) s += '<div class="tt-ptile' + (i === MIN - 1 ? ' tt-ptile-gift' : '') + '"><span class="tt-slot-n">' + (i === MIN - 1 ? 'FREE' : i + 1) + '</span><span class="tt-sn">' + (i === MIN - 1 ? '1 free' : 'Pick a print') + '</span></div>';
      if (isPush(t)) for (var j = 0; j < t.k; j++) s += '<button type="button" class="tt-ptile tt-ptile-more tt-ptile-push' + (j === t.k - 1 ? ' tt-ptile-gift' : '') + '" data-tt-scroll aria-label="' + esc(pushTxt(t)) + '"><span class="tt-slot-n">' + (j === t.k - 1 ? 'FREE' : '+') + '</span><span class="tt-sn">' + (j === t.k - 1 ? 'Next free' : 'Pick #' + (t.n + j + 1)) + '</span></button>';
      if (isSet(t)) s += '<button type="button" class="tt-ptile tt-ptile-more" data-tt-scroll aria-label="' + esc(nudgeTxt()) + '"><span class="tt-slot-n">+' + MIN + '</span><span class="tt-sn">Another free</span></button>';
      return s;
    };
    fixOrder = function () { return Promise.resolve(); };
    /* put the B2G1 code on the cart (kept if already there) + tag the cart for the cart popup / cart page */
    var ensureCode = function () {
      if (!CODE) return Promise.resolve();
      return (C ? Promise.resolve(C) : getCart()).then(function (c) {
        /* never on an empty cart: a code put on an empty cart can't be fully removed later (towel-deal), see ensureSets3 */
        if (!c.item_count) return;
        var has = (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === CODE.toUpperCase(); });
        var a = c.attributes || {}, land = D.landing || 'buy-2-get-1', ttag = (window.ttAttr && window.ttAttr.offer()) || 'b2g1', tagged = a._tt_offer === ttag && a._landing === land; /* Oct 25 2026: ad tt_offer (assets/tt-attr.js) replaces b2g1 as the tag; tracking only */
        if (has && tagged) return;
        var b = { attributes: { _tt_offer: ttag, _landing: land } };
        /* Oct 8 2026: /cart/update.js {discount} replaces every code, so send the codes already on the cart (SHIPFREE, ...) + CODE */
        if (!has) b.discount = (c.discount_codes || []).map(function (d) { return String(d.code); }).filter(function (x) { return x && x.toUpperCase() !== CODE.toUpperCase(); }).concat(CODE).join(',');
        return req('cart/update.js', b).then(function (r) { if (r.ok && r.j && r.j.items) { C = r.j; if (!has) publishCart(); } });
      });
    };
    resync = function () { C = null; return getCart().then(ensureCode).then(function () { reconcile(); synced = true; render(); fixBubble(); }).catch(function () { synced = true; render(); }); };
    /* after adds: keep the B2G1 code + tags on the cart (instead of the sets-of-3 guard) */
    settle = function () {
      return (C ? Promise.resolve(C) : getCart()).then(function () {
        if (pending) return;
        return ensureCode().then(function () { reconcile(); render(); publishCart(); return tagCart(); });
      }).catch(function () { render(); });
    };
    var coAnyway = function () {
      var m = $('#tt-tray [data-tt-co-main]'); if (!m) return null;
      var a = $('#tt-tray [data-tt-co-anyway]');
      if (!a) { a = document.createElement('button'); a.type = 'button'; a.className = 'tt-co-anyway'; a.setAttribute('data-tt-co-anyway', ''); a.hidden = true; m.parentNode.insertBefore(a, m.nextSibling); }
      return a;
    };
    var renderBase = render;
    render = function () {
      renderBase.apply(this, arguments);
      var a = coAnyway(); if (!a) return;
      var t = totals(), on = freeNext(t);
      a.hidden = !on;
      if (on && !a.classList.contains('is-busy')) a.textContent = 'or check out now · ' + t.n + ' towel' + (t.n > 1 ? 's' : '') + ' · ' + money(t.now);
      var m = $('#tt-tray [data-tt-co-main]'); if (m) m.classList.toggle('is-pick', on);
      /* Oct 20 2026 (lp-oct20): "Discount applied automatically" under the button once a free towel is in the cart */
      if (m) {
        var ad = $('#tt-tray [data-tt-auto]');
        if (!ad) { ad = document.createElement('p'); ad.className = 'tt-auto-disc'; ad.setAttribute('data-tt-auto', ''); ad.textContent = '\u2713 Discount applied automatically'; var after = a || m; after.parentNode.insertBefore(ad, after.nextSibling); }
        var show = t.sets > 0 && !t.off && !pending;
        if (ad.hidden === show) { ad.hidden = !show; document.dispatchEvent(new Event('tt:measure')); }
      }
    };
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-tt-co-anyway]');
      if (a) { e.preventDefault(); checkout(a, true); }
    });
    checkout = function (btn, anyway) {
      if (!picks.length && !pending) { toBuild(); return; }
      if (!anyway && freeNext(totals())) { toBuild(); return; }
      if (btn.classList.contains('is-busy')) return;
      busyBtn(btn, true); btn.textContent = 'Opening checkout…';
      chain.then(getCart).then(function (c) {
        if (!c.item_count) { busyBtn(btn, false); reconcile(); render(); toBuild(); return; }
        return ensureCode().then(tagCart).then(function () { location.href = ROOT + 'checkout'; });
      }).catch(function () { busyBtn(btn, false); msg('Something went wrong. Please try again or <a href="' + CART_URL + '">view your cart</a>.'); });
    };
  }

  render();
  var ready = resync();
  chain = ready;
})();
